enum EmailOnboardingActionTypes {
	EMAIL_ONBOARDING_NYLAS_SIGNUP_REQUEST = 'emailOnboarding/NYLAS_SIGNUP_REQUEST',
	EMAIL_ONBOARDING_NYLAS_CALENDAR_SIGNUP_REQUEST = 'emailOnboarding/NYLAS_CALENDAR_SIGNUP_REQUEST'
}

export { EmailOnboardingActionTypes };
